import { render, staticRenderFns } from "./search-people.vue?vue&type=template&id=1b96cc8c&lang=pug&"
import script from "./search-people.vue?vue&type=script&lang=js&"
export * from "./search-people.vue?vue&type=script&lang=js&"
import style0 from "./search-people.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports